import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { getallClassify, addMsg, udataMsg, returnMsg } from "@/api/dataAll/gamestyle";
export default {
  name: "addMsgSharing",
  props: {
    showing: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      dialogFormVisible: false,
      titleName: "",
      id: "",
      form: {
        classify: '',
        game: ''
      }
    }, _defineProperty(_ref, "id", ""), _defineProperty(_ref, "classifyData", []), _defineProperty(_ref, "rules", {// game: [{ required: true, message: "游戏", trigger: "blur" }],
      // platform: [{ required: true, message: "平台", trigger: "blur" }],
      // parameter: [{ required: true, message: "参数", trigger: "blur" }],
    }), _defineProperty(_ref, "formLabelWidth", "80px"), _ref;
  },
  created: function created() {
    var _this = this;

    this.searchMark = {};
    getallClassify().then(function (res) {
      _this.classifyData = res.data;
    });
  },
  computed: {
    isShow: {
      get: function get() {
        if (this.isShowing) {
          return this.isShowing;
        }
      },
      set: function set(val) {
        this.$emit("changeShow", false);
      }
    }
  },
  methods: {
    init: function init(id, num) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tid, _yield$returnMsg, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.dialogFormVisible = true;

                if (num == 1) {
                  _this2.titleName = "新增游戏映射";
                  _this2.form = {};
                }

                _this2.id = id;

                if (!(id != "t")) {
                  _context.next = 18;
                  break;
                }

                if (!(num == 2)) {
                  _context.next = 18;
                  break;
                }

                _this2.titleName = "修改游戏映射";
                _this2.id = id;
                tid = {
                  id: id
                };
                _context.next = 10;
                return returnMsg(tid);

              case 10:
                _yield$returnMsg = _context.sent;
                data = _yield$returnMsg.data;
                _this2.form.classify = data.classify;
                _this2.searchMark.classify = data.classify;
                _this2.form.game = data.game;
                _this2.searchMark.game = data.game;
                _this2.searchMark.id = data.id;

                _this2.$set(_this2.form, _this2.form.classify, "");

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    textChange: function textChange(val) {
      //  this.form.textarea2= val
      this.searchMark.game = val;
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.$emit("changeShow", false);
    },
    classifychange: function classifychange(val) {
      this.searchMark.classify = val;
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this3 = this;

      if (this.titleName == "新增游戏映射") {
        this.searchMark.kind = 1;
        addMsg(this.searchMark).then(function (res) {
          if (res.status == 200) {
            Message.success(res.message); // this.$emit("refreshDataList");

            _this3.resetForm("ruleForm");
          } else {
            Message.warning(res.message);

            _this3.resetForm("ruleForm");
          }
        });
      }

      if (this.titleName == "修改游戏映射") {
        udataMsg(this.searchMark).then(function (res) {
          if (res.status == 200) {
            Message.success(res.message);

            _this3.$emit("refreshDataList");

            _this3.resetForm("ruleForm");
          } else {
            Message.warning(res.message);
          }
        });
      }
    },
    clearData: function clearData() {
      this.form = {};
      this.searchMark = {};
    }
  }
};